import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('menucard-component', {
    data() {
        return {
            tabIndex: 0,
            contentSections: null
        };
    },

    mounted() {
        Vue.nextTick(this.initColumns);
    },

    methods: {
        async initColumns() {
            const Colcade = await import(/* webpackChunkName: "vendors~colcade" */ 'colcade')
                .then(module => {
                    return module.default
                }) // using the default export
                .catch(() => {
                    console.log('Handle error!');
                });

            const menuCardSection = [...this.$el.querySelectorAll('.menucard__sections')];

            for (let index = 0; index < menuCardSection.length; index++) {
                const element = menuCardSection[index];

                this.colcade = new Colcade(element, {
                    columns: '.menucard-grid-col',
                    items: '.menucard__section'
                });
            }

            // Set active when pdf is first element
            this.contentSections = this.$el.querySelectorAll('.menucard__bar-tab');

            for (let i = 0; i < this.contentSections.length; i++) {
                const { type, loopIndex } = this.contentSections[i].dataset;

                if (type === 'section') {
                    this.tabIndex = Number(loopIndex);
                    this.switchTab(Number(loopIndex));
                    break;
                }
            }
        },

        switchTab(index) {
            const element = this.contentSections[index];
            var rect = element.getBoundingClientRect();

            var parent = element.parentElement;
            parent.scrollLeft = parent.scrollLeft + rect.left - 30;

            if (index != this.tabIndex) {
                // gsap animation fade out dan index wijzigen en dan fade in
                gsap.fromTo('.menucard__tab', { opacity: 1 }, { opacity: 0, duration: 0.5 })
                gsap.delayedCall(0.6, () => {
                    this.tabIndex = index;
                    gsap.fromTo('.menucard__tab', { opacity: 0 }, { opacity: 1, duration: 1 })
                })

            }

        },

        goToPreviousBarTab() {
            var activeTab = this.$el.querySelector(".menucard__bar-tab--active");
            let element = null;

            const { loopIndex } = activeTab.dataset;

            let activeTabIndex = Number(loopIndex) - 1;

            while (activeTabIndex > -1 && !element) {
                const { type: siblingType } = this.contentSections[activeTabIndex].dataset;

                if (siblingType === 'section') {
                    element = this.contentSections[activeTabIndex];
                }

                activeTabIndex--;
            }

            if (!element) {
                return;
            }

            activeTab.classList.remove("menucard__bar-tab--active");
            element.classList.add('menucard__bar-tab--active');

            var rect = element.getBoundingClientRect();
            var parent = element.parentElement;

            parent.scrollLeft = parent.scrollLeft + rect.left - 30;

            this.switchTab(element.getAttributeNode("data-loop-index").value)
        },

        goToNextBarTab() {
            const activeTab = this.$el.querySelector(".menucard__bar-tab--active");
            let element = null;

            const { loopIndex } = activeTab.dataset;

            let activeTabIndex = Number(loopIndex) + 1;

            for (let i = activeTabIndex; i < this.contentSections.length; i++) {
                const { type: siblingType } = this.contentSections[i].dataset;

                if (siblingType === 'section') {
                    element = this.contentSections[i];
                    break;
                }
            }

            if (!element) {
                return;
            }

            activeTab.classList.remove("menucard__bar-tab--active");
            element.classList.add('menucard__bar-tab--active');

            var rect = element.getBoundingClientRect();
            var parent = element.parentElement;

            parent.scrollLeft = parent.scrollLeft + rect.left - 30;

            this.switchTab(element.getAttributeNode("data-loop-index").value)


        }

    },
});
